import type {ValueOf} from '@myparcel-frontend/types';

export const Hosts = {
  DEFAULT: 'myparcel.nl',
  MYPARCEL_NL: 'myparcel.nl',
  MYPARCEL_BE: 'sendmyparcel.be',
  MYPARCEL_COM: 'myparcel.com',
  MYPARCEL_DEV: 'myparcel.dev',
} as const;

export const ApplicationKey = {
  MYPARCEL_NL: 'myparcel-nederland',
  MYPARCEL_BE: 'myparcel-belgie',
  MYPARCEL_COM: 'myparcel-com',
} as const;

export const HostToApplicationKeyMap = {
  [Hosts.MYPARCEL_NL]: ApplicationKey.MYPARCEL_NL,
  [Hosts.MYPARCEL_BE]: ApplicationKey.MYPARCEL_BE,
  [Hosts.MYPARCEL_COM]: ApplicationKey.MYPARCEL_COM,
  [Hosts.MYPARCEL_DEV]: ApplicationKey.MYPARCEL_COM,
} as const;

export const toApplicationKey = <T extends ValueOf<typeof Hosts>>(host: T) => {
  return HostToApplicationKeyMap[host];
};
